import type { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/query";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { setAuthError } from "@store/slices/authError";
import { sleep } from "@store/utils";
import localStorageSecureWrapper from "@utilities/localStorageSecureWrapper";
import { currentConfig } from "app.config";

import { setInterceptor } from "./interceptors";

const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, object, FetchBaseQueryMeta> = fetchBaseQuery({
  baseUrl: process.env.NODE_ENV === "development" 
    ? "/gamification-middleware" 
    : currentConfig.REACT_APP_API_URL,
  prepareHeaders: setInterceptor,
});



export const fetchWithRetry: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, object, FetchBaseQueryMeta>  = async (args, api, extraOptions) => {
  const response = await baseQuery(args, api, extraOptions);
  
  if (response.error?.status === 401) {
    
    window.parent.postMessage({ type: "TOKEN_EXPIRED" }, "*");

    await sleep(1500);

    // Retry the request with the (hopefully) new token
    const retryResponse = await baseQuery(args, api, extraOptions);

    if (retryResponse.error?.status === 401) {

      // Token refresh failed - dispatch error action to show error page
      // This breaks the infinite loop by stopping further retries
      api.dispatch(setAuthError());
      localStorageSecureWrapper.clear();
      
      return retryResponse;
    }
    
    return retryResponse;
  }
  
  return response;
};
